import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import AddConstraintModal from './AddConstraintModal';

const formatConstraintParams = (constraint, typeDef) => {
    if (!typeDef) return JSON.stringify(constraint);
    return Object.entries(typeDef.paramSchema)
        .map(([key]) => {
            const val = constraint[key];
            if (Array.isArray(val)) return val.join(', ');
            if (val != null && typeof val === 'object') {
                if (val.kind === 'lineupOrder') return `#${val.order}`;
                if (val.kind === 'position') return val.position;
                return val.cardID;
            }
            return String(val ?? '');
        })
        .filter(Boolean)
        .join(' | ');
};

const ConstraintEditor = ({ constraints, onChange, constraintTypeDefs }) => {
    const [showModal, setShowModal] = useState(false);

    const typeMap = useMemo(
        () => new Map(constraintTypeDefs.map(t => [t.type, t])),
        [constraintTypeDefs],
    );

    const handleRemove = index => {
        onChange(constraints.filter((_, i) => i !== index));
    };

    const handleAdd = constraint => {
        onChange([...constraints, constraint]);
    };

    return (
        <div className="constraint-editor">
            <label>Constraints:</label>
            {constraints.length > 0 && (
                <div className="constraint-chips">
                    {constraints.map((constraint, index) => {
                        const def = typeMap.get(constraint.type);
                        return (
                            <span key={index} className="constraint-chip">
                                <strong>{def?.label || constraint.type}</strong>
                                {' '}{formatConstraintParams(constraint, def)}
                                <button type="button" onClick={() => handleRemove(index)} aria-label="Remove constraint">
                                    &times;
                                </button>
                            </span>
                        );
                    })}
                </div>
            )}
            <button type="button" className="btn-secondary constraint-add-btn" onClick={() => setShowModal(true)}>
                + Add Constraint
            </button>
            {showModal && (
                <AddConstraintModal
                    constraintTypeDefs={constraintTypeDefs}
                    onAdd={handleAdd}
                    onClose={() => setShowModal(false)}
                />
            )}
        </div>
    );
};

ConstraintEditor.propTypes = {
    constraints: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    constraintTypeDefs: PropTypes.array.isRequired,
};

export default ConstraintEditor;
